import React, { createContext, useState } from 'react';

export const SuperviseeContext = createContext();

export const SuperviseeProvider = ({ children }) => {
    const [currentSuperviseeId, setCurrentSuperviseeId] = useState(null);

    return (
        <SuperviseeContext.Provider value={{ currentSuperviseeId, setCurrentSuperviseeId }}>
            {children}
        </SuperviseeContext.Provider>
    );
};
